import { BatchClassConfig } from "../../models/config/BatchClassConfig";
import { BatchClassMetadataData } from "../../models/config/BatchClassMetadata";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTActionBarBatchClass } from "../tooltips/ConfigurationTooltips";
import { FilterableActionBarCategory } from "./FilterableActionBarCategory";
import { Text } from "./items/Text";

export { BatchClassCategory };

type Props = {
  batchClassConfig?: BatchClassConfig | BatchClassMetadataData;
  batchClassConfigs: BatchClassMetadataData[];
  changeBcc: (batchClassConfig: BatchClassMetadataData) => void;
};

const BatchClassCategory = (props: Props) => {
  const bccName = props.batchClassConfig
    ? "batchClassName" in props.batchClassConfig && props.batchClassConfig.batchClassName
      ? props.batchClassConfig.batchClassName
      : (props.batchClassConfig as BatchClassMetadataData).name ?? ""
    : "";
  const batchClassCategoryTitle = props.batchClassConfig
    ? `${props.batchClassConfig.batchClassId} - ${bccName}`
    : "";
  return (
    <AdvancedTooltip
      overflow
      tooltipText={TTActionBarBatchClass}
      possiblePlacements={["left-center"]}
    >
      {(tProps) => (
        <FilterableActionBarCategory
          tProps={tProps}
          title={props.batchClassConfig ? batchClassCategoryTitle : ""}
          // stretch to width of children
          stretch
          list={props.batchClassConfigs}
        >
          {(bcc, itemProps) => (
            <Text
              {...itemProps}
              key={bcc.batchClassId}
              onClick={() => props.changeBcc(bcc)}
            >
              <>
                {bcc.batchClassId} - {bcc.name}
              </>
            </Text>
          )}
        </FilterableActionBarCategory>
      )}
    </AdvancedTooltip>
  );
};
